<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 900px; margin-bottom: 10px">
        <div style="padding: 10px; display: flex; justify-content: left; align-items: center; font-size: 14px">
          <div>
            @if (motoristList) {
              <div style="display: flex">
                <div class="data-label">Motorist ID:</div>
                <div>{{ motoristList }}</div>
              </div>
            }
            @if (plateList) {
              <div style="display: flex">
                <div class="data-label" style="margin-left: 10px">Plate Number:</div>
                <div>{{ plateList }}</div>
              </div>
            }
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: center; align-items: top; width: 100%; max-width: 900px; margin-bottom: 10px; flex-wrap: wrap; gap: 10px">
        <div style="margin-right: 5px; width: 100%; max-width: 440px">
          <app-credit-card-information
            #creditCardPanel
            [(ccInfo)]="ccInfo"
            [validationGroup]="validationGroup"
          [site]="site"></app-credit-card-information>
        </div>
        <div style="margin-left: 5px; width: 100%; max-width: 440px">
          <app-tickets-to-pay [ticketList]="ticketList" [validationGroup]="validationGroup"></app-tickets-to-pay>
        </div>
      </div>
      <div style="width: 100%; max-width: 900px; margin-bottom: 10px">
        <app-mandatory-terms [site]="site" [validationGroup]="validationGroup"></app-mandatory-terms>
      </div>
      <div style="width: 100%; max-width: 900px">
        <app-finalize-payment
          [(ccInfo)]="ccInfo"
          [processingFee]="processingFee"
          [totalWithFee]="totalWithFee"
          [feeReady]="feeReady"
          [validationGroup]="validationGroup"
          [pageLoaderID]="componentID"
        [site]="site"></app-finalize-payment>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
